import ApiService from "../ApiService";

/**
 * @see /docs/api/index.html#Report
 */

const DefaultedContractsService = {
  /**
   * View DefaultedContracts report data
   * @param array data pass serach filter values if needed
   * @see /docs/api/index.html#jump-Report-DefaultedContracts
   * @returns
   */
  view: (data, param, signal) => {
    return ApiService.post(
      "/report/defaulted-contracts/index",
      data,
      param,
      signal
    ).catch((error) => {
      console.log(error);
      return error;
    });
  },
};

export default DefaultedContractsService;
